import React from 'react';
import { findKpiAttributes, type OmdProduct } from '../../../utils/omdProductView';

export function OmdKpiChips({ product }: { product: OmdProduct }) {
  const chips = findKpiAttributes(product);
  if (chips.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2">
      {chips.map((chip) => (
        <div
          key={chip.label}
          className="rounded-md border border-app-border bg-app-surface-muted px-2.5 py-1.5 min-w-[7rem]"
        >
          <p className="text-xs font-medium text-app-text-muted">{chip.label}</p>
          <p className="text-sm font-semibold text-app-text tabular-nums mt-0.5">{chip.value}</p>
        </div>
      ))}
    </div>
  );
}
